<av-content-container [fullHeight]="true">
    <div class="col-12">
        <div class="av-billing-page">
            <div class="av-billing-heading">
                <h1 class="mb-1">{{ 'app.billing.licences.title' | translate }}</h1>
                <p class="av-billing-note m-0">{{ 'app.billing.licences.subtitle' | translate }}</p>
            </div>

            @if (facade.errorMessageKey(); as errorKey) {
            <div class="av-billing-banner">
                <div class="d-flex align-items-center gap-2">
                    <mat-icon>error_outline</mat-icon>
                    <span class="fw-semibold">{{ errorKey | translate }}</span>
                </div>
            </div>
            } @else {
            <div class="row g-4">
                @for (component of facade.availableComponents(); track component.component_type) {
                <div class="col-12 col-lg-6">
                    <app-licence-component-card [component]="component" (buy)="buyLicences($event)"
                        (cancel)="cancelLicences($event)"></app-licence-component-card>
                </div>
                }
            </div>

            <div class="av-licence-roster">
                <app-licence-roster-table [licences]="facade.licences()" [isLoading]="facade.isLoading()"
                    (reload)="facade.reload()" (assign)="assignLicence($event)" (release)="releaseLicence($event)"
                    (resume)="resumeLicence($event)"></app-licence-roster-table>
            </div>
            }
        </div>
    </div>
</av-content-container>
